const KPI_TRANSLATION_PREFIX = "benchmarking.evaluations.key-figures.scorecards";

export const KPI_SCORECARD_TRANSLATION_KEYS = {
  formulaLabel: "Formula", //`${KPI_TRANSLATION_PREFIX}.formula-label`,
  interpretationLabel: "Interpretation", //`${KPI_TRANSLATION_PREFIX}.interpretation-label`,
  empty: `${KPI_TRANSLATION_PREFIX}.empty`,
  loading: `${KPI_TRANSLATION_PREFIX}.loading`,
  sectionTitle: `${KPI_TRANSLATION_PREFIX}.section-title`,
  displayMyData: `${KPI_TRANSLATION_PREFIX}.display-my-data`,
  legend: {
    label: `${KPI_TRANSLATION_PREFIX}.legend.label`,
    title: `${KPI_TRANSLATION_PREFIX}.legend.title`,
    description: `${KPI_TRANSLATION_PREFIX}.legend.description`,
    normalDistribution: `${KPI_TRANSLATION_PREFIX}.legend.normal-distribution`,
    mean: `${KPI_TRANSLATION_PREFIX}.legend.mean`,
    sd: `${KPI_TRANSLATION_PREFIX}.legend.standard-deviation`,
    higher: `${KPI_TRANSLATION_PREFIX}.legend.higher-is-better`,
    lower: `${KPI_TRANSLATION_PREFIX}.legend.lower-is-better`,
    belowFair: `${KPI_TRANSLATION_PREFIX}.legend.below-fair`,
    fair: `${KPI_TRANSLATION_PREFIX}.legend.fair`,
    good: `${KPI_TRANSLATION_PREFIX}.legend.good`,
    veryGood: `${KPI_TRANSLATION_PREFIX}.legend.very-good`,
    close: `${KPI_TRANSLATION_PREFIX}.legend.close`,
  },
};

const kpiTranslationKeys = (slug) => ({
  titleKey: `${KPI_TRANSLATION_PREFIX}.kpis.${slug}.title`,
  formulaKey: `${KPI_TRANSLATION_PREFIX}.kpis.${slug}.formula`,
  interpretationKey: `${KPI_TRANSLATION_PREFIX}.kpis.${slug}.interpretation`,
});

const KPI_DEFINITIONS = [
  {
    id: "totalCostsRatio",
    direction: "lower",
    unit: "percent",
    aliases: ["total-costs-ratio", "total_costs_ratio", "total cost ratio", "total costs ratio", "totalCostsToRevenue"],
    ...kpiTranslationKeys("total-costs-ratio"),
  },
  {
    id: "revenuePerFte",
    direction: "higher",
    unit: "currency",
    aliases: ["revenue-per-fte", "revenue_per_fte", "revenue per fte", "revenue per full-time position", "turnover per fte"],
    ...kpiTranslationKeys("revenue-per-fte"),
  },
  {
    id: "totalCostsPerFte",
    direction: "lower",
    unit: "currency",
    aliases: ["total-costs-per-fte", "total_costs_per_fte", "total costs per fte", "total cost per fte"],
    ...kpiTranslationKeys("total-costs-per-fte"),
  },
  {
    id: "overheadRatio",
    direction: "lower",
    unit: "percent",
    aliases: ["overhead-ratio", "overhead_ratio", "overhead ratio", "overhead factor"],
    ...kpiTranslationKeys("overhead-ratio"),
  },
  {
    id: "fullCostPerHour",
    direction: "lower",
    unit: "currencyPerHour",
    aliases: ["full-cost-per-hour", "full_cost_per_hour", "full cost per hour", "average hour", "average hourly rate"],
    ...kpiTranslationKeys("full-cost-per-hour"),
  },
  {
    id: "productivityRate",
    direction: "higher",
    unit: "percent",
    aliases: ["productivity-rate", "productivity_rate", "productivity rate", "productivity"],
    ...kpiTranslationKeys("productivity-rate"),
  },
];

const normalize = (value) =>
  String(value == null ? "" : value)
    .toLowerCase()
    .replace(/[^a-z0-9à-ÿ]+/g, " ")
    .trim();

const translateKey = (translate, key) => (typeof translate === "function" ? translate(key) : key);

export function getOrderedKpiDefinitions(translate) {
  return KPI_DEFINITIONS.map((definition, displayOrder) => ({
    ...definition,
    displayOrder,
    title: translateKey(translate, definition.titleKey),
    formula: translateKey(translate, definition.formulaKey),
    interpretation: translateKey(translate, definition.interpretationKey),
  }));
}

export function matchesKpiDefinition(rawKpi, definition) {
  const identifier = rawKpi?.kpiId ?? rawKpi?.figureName;
  if (identifier == null) return false;
  const candidate = normalize(String(identifier).replace(/^business_key_figures\./, ""));
  return [definition.id, ...definition.aliases].some((alias) => normalize(alias) === candidate);
}
